module.exports = __webpack_public_path__ + "static/media/plant.532ee342.png";